export default "__VITE_ASSET__93eb05cc__"